import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button} from "@chakra-ui/react";
import {Header, Title} from "../sheet";

const CardPaymentSuccessSheet = styled(({className, onClose}) => {

        return (
            <div className={className}>

                <Header>
                    <Title>Success!</Title>
                </Header>

                <p>We've received your payment - your purchase should go through any moment now.</p>

                <Button variant="grey" width={"100%"} onClick={onClose}>
                    Done
                </Button>

            </div>
        );
    }
)`
  p {
    font-size: 17px;
  }
`;

export default CardPaymentSuccessSheet;
